import { Badge, Typography } from '@components/ui';
import React from 'react';
import Highlighter from 'react-highlight-words';
import { useTheme } from 'styled-components';
import Avatar from '../../../../components/avatar';
import { ChatPreviewItemSC } from './chat-preview.styled';
import { TInboxItem } from './chat-preview.types';

type TProps = {
  item: TInboxItem;
  query: string;
};

const ChatPreviewItem: React.FC<TProps> = ({ query, item }: TProps) => {
  const theme = useTheme();

  return (
    <ChatPreviewItemSC to={`/life-id/${item.patient.id}`}>
      <div className="chp-avatar">
        <Badge
          content={item.unreadsCount}
          positionHorizontal="right"
          positionVertical="top"
          badgeStyle={{ top: -2 }}
        >
          <Avatar imgUrl={item.patient.profile.profileImage} size={40} />
        </Badge>
      </div>
      <div className="chp-text">
        <Typography display="body1" variant="strong">
          <Highlighter searchWords={[query]} textToHighlight={item.fullName} />
        </Typography>
        <Typography display="body2" style={{ color: theme.color.tint.secondary }}>
          {item.messagePreview}
        </Typography>
      </div>
    </ChatPreviewItemSC>
  );
};

export default ChatPreviewItem;
